module.exports = __webpack_public_path__ + "static/celerBridge-c14201167e98faf18e3cace9b2f18103.png";